import React from 'react';
import { useHistory } from 'react-router';

import { Container } from './styles';

function BannerCallToAction({ info, action, bannerImg }) {
  const { push } = useHistory();

  const handleItemClick = to => {
    push(to);
  };

  return (
    <Container>
      <div className="banner">
        <img src={bannerImg} />
      </div>
      <div className="info">
        <h3 className="info__title">{info.title}</h3>
        <span className="info__description">{info.description}</span>
        <button
          className="info__action"
          onClick={() => handleItemClick(action.to)}
        >
          {action.buttonText}
        </button>
      </div>
    </Container>
  );
}

export default BannerCallToAction;
